import { makeStyles, createStyles } from '@material-ui/core/styles';

const drawerWidth = 220;

export const useStylesGlobal = makeStyles((theme) => createStyles({
  root: {
    display: 'flex',
    width: '100%',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  contentModeTest: {
    marginTop: "20px",
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
    // height: '100vh',
    fontSize: '13px !important',
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  // pas encore vu 
  //PAGE Aprecu
  formControl: {
    marginBottom: theme.spacing(3),
    width: "32.5%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },

  // PAGE InscriptionWish / EmailList
  appBarBg: {
    backgroundColor: "#FFFFFF",
  },successBtn: {
    backgroundColor: "#388e3c",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#2b6e2e",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#388e3c",
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#2b6e2e",
      }
    }
  },
  buttonFermer: {
    backgroundColor: "#d32f2f",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#ab2626",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#d32f2f",
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#ab2626",
      }
    }
  },
  standardBtn: {
    backgroundColor: "#627998",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#4e5f77",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#627998",
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#4e5f77",
      }
    }
  },
  errorBtn: {
    backgroundColor: "#c00000",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#8f0000",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#c00000",
      color: "#FFFFFF",
      "&:hover": {
        backgroundColor: "#8f0000",
      }
    }
  },
  warningBtn: {
    backgroundColor: "#ffc000",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#e0a800",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#ffc000",
      color: "#000000",
      "&:hover": {
        backgroundColor: "#e0a800",
      }
    }
  },
  defaultBtn: {
    backgroundColor: "#e7e6e6",
    color: "#000000",
    "&:hover": {
      backgroundColor: "#cfcfcf",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#e7e6e6",
      color: "#000000",
      "&:hover": {
        backgroundColor: "#cfcfcf",
      }
    }
  },
  blueBtn: {
    backgroundColor: "#1976d2",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#145ca4",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#1976d2",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#145ca4",
      }
    }
  },
  grisBtn: {
    backgroundColor: "#7f7f7f",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#cfcfcf",
    },
    "&.MuiButton-root": { 
      backgroundColor: "#7f7f7f",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#cfcfcf",
      }
    }
  },
  grisBtnLigth: {
    backgroundColor: "hsla(0,0%,0%,0.15)",
    color: "#fff",
    "&:hover": {
      backgroundColor: "hsla(0,0%,0%,0.3)",
    },
    "&.MuiButton-root": { 
      backgroundColor: "hsla(0,0%,0%,0.15)",
      color: "#fff",
      "&:hover": {
        backgroundColor: "hsla(0,0%,0%,0.3)",
      }
    }
  },
  successLightBtn: {
    backgroundColor: '#92d050',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#75b843',
    },
    "&.MuiButton-root": { 
      backgroundColor: '#92d050',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#75b843',
      }
    }
  },
  successDarkBtn: {
    backgroundColor: '#00b050',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#008040',
    },
    "&.MuiButton-root": { 
      backgroundColor: '#00b050',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#008040',
      }
    }
  },
  btnTableau: {
    width: "100%",
  },
  remarqueFaible: {
    backgroundColor: '#89B4E7',
  },
  remarqueModerer: {
    backgroundColor: '#FED56E',
    color: '#000',
  },
  remarqueElever: {
    backgroundColor: '#EB4B43',
  }
}));
